/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientCareSurveySelectionProcessModel } from '../../models/client-care-survey-selection-process-model';

export interface GetClientSurveysReport$Json$Params {

/**
 * id of the client care rep in AD
 */
  repId?: number;

/**
 * surveytype id filter
 */
  surveyTypeId: number;

/**
 * year filter
 */
  year: number;

/**
 * month filter 1-12
 */
  month: number;

/**
 * if supplied, will search records on the attorney name
 */
  attorneyName?: string;

/**
 * if supplied, will search records on the matter name
 */
  matterName?: string;

/**
 * if supplied, will search records on the matter number
 */
  matterNumber?: string;

/**
 * records to skip
 */
  skip?: number;

/**
 * records to take
 */
  take?: number;
}

export function getClientSurveysReport$Json(http: HttpClient, rootUrl: string, params: GetClientSurveysReport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientCareSurveySelectionProcessModel>> {
  const rb = new RequestBuilder(rootUrl, getClientSurveysReport$Json.PATH, 'get');
  if (params) {
    rb.query('repId', params.repId, {});
    rb.query('surveyTypeId', params.surveyTypeId, {});
    rb.query('year', params.year, {});
    rb.query('month', params.month, {});
    rb.query('attorneyName', params.attorneyName, {});
    rb.query('matterName', params.matterName, {});
    rb.query('matterNumber', params.matterNumber, {});
    rb.query('skip', params.skip, {});
    rb.query('take', params.take, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientCareSurveySelectionProcessModel>;
    })
  );
}

getClientSurveysReport$Json.PATH = '/api/Report/ClientsToContact';
